module.exports = __webpack_public_path__ + "static/media/airbnb_round.5df2f16a.svg";